import PainIndex from '../styles/images/PainIndex.png';

export default {};
export const PAININDEX = {
  PainIndex,
};



// WEBPACK FOOTER //
// ./src/constants/PainIndexImage.js